import React, { useState, useContext } from 'react';
import {
	Paper,
	Container,
	Button,
	Stack,
	TextField,
	FormControl,
	InputLabel,
	Select,
	MenuItem
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import moment from 'moment/moment';
import { simpleMessage } from '../../../../helpers/Helpers';
import { addSubcidioAsync } from '../../../../api/Nomina';
import { getToken } from '../../../../api/Account';
import { DataContext } from '../../../../context/DataContext';

const AddSubcidio = ({ id, setShowModal, reload, setReload }) => {
	const [desde, setDesde] = useState(new Date());
	const [hasta, setHasta] = useState(new Date());
	const [riesgoLaboral, setRiesgoLaboral] = useState(1);
	const [motivo, setMotivo] = useState('');

	const { setIsLoading, setIsUnautorized } = useContext(DataContext);

	const token = getToken();

	const saveChanges = async () => {
		if (moment(desde).isAfter(moment(hasta))) {
			simpleMessage('Ingrese un rango de fechas correcto', 'error');
			return;
		}
		if (moment(hasta).diff(moment(desde), 'days') <= 2) {
			simpleMessage('No puede agregar un subcidio menor a 3 días', 'error');
			return;
		}

		if (motivo.length === 0) {
			simpleMessage('Ingrese un motivo', 'error');
			return;
		}

		const data = {
			employeeId: parseInt(id),
			motivo,
			desde: moment(desde).format('YYYY-MM-DD'),
			hasta: moment(hasta).format('YYYY-MM-DD'),
			isRiesgoLaboral: riesgoLaboral === 1
		};

		setIsLoading(true);
		const result = await addSubcidioAsync(token, data);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}
		setIsLoading(false);
		simpleMessage('Subcidio Agregado...!', 'success');
		setReload(!reload);
		setShowModal(false);
	};
	
	return (
		<div>
			<Container style={{ width: 550 }}>
				<Paper
					elevation={10}
					style={{
						padding: 20
					}}
				>
					<Stack spacing={2}>
						<Stack spacing={2} direction="row">
							<DesktopDatePicker
								closeOnSelect
								label="Desde"
								inputFormat="DD/MM/YYYY"
								value={desde}
								onChange={(newValue) => setDesde(newValue)}
								renderInput={(params) => <TextField {...params} />}
							/>

							<DesktopDatePicker
								closeOnSelect
								label="Hasta"
								inputFormat="DD/MM/YYYY"
								value={hasta}
								onChange={(newValue) => setHasta(newValue)}
								renderInput={(params) => <TextField {...params} />}
							/>
						</Stack>

						<FormControl fullWidth style={{ textAlign: 'left', marginTop: 20 }}>
							<InputLabel id="demo-simple-select-standard-label">
								Tipo Subcidio
							</InputLabel>
							<Select
								labelId="demo-simple-select-standard-label"
								id="demo-simple-select-standard"
								onChange={(e) => setRiesgoLaboral(e.target.value)}
								value={riesgoLaboral}
								label="Tipo Subcidio"
							>
								<MenuItem value={1}>RIESGO LABORAL</MenuItem>
								<MenuItem value={2}>ENFERMEDAD COMUN</MenuItem>
								<MenuItem value={3}>OTRA CAUSA</MenuItem>
							</Select>
						</FormControl>

						<TextField
							required
							fullWidth
							onChange={(e) => setMotivo(e.target.value.toLocaleUpperCase())}
							value={motivo}
							label={'Motivo'}
						/>

						<Button
							variant="outlined"
							startIcon={
								<FontAwesomeIcon icon={faCirclePlus} style={{ marginRight: 20 }} />
							}
							fullWidth
							onClick={() => saveChanges()}
							style={{
								borderRadius: 30,
								color: '#4caf50',
								borderColor: '#4caf50',
								padding: 12
							}}
							size="large"
						>
							Agregar Subcidio
						</Button>
					</Stack>
				</Paper>
			</Container>
		</div>
	);
};

export default AddSubcidio;
